exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "\n.Page {\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n}\n", "",{"version":3,"sources":["H:/JENKINS_HOME_NANTU/workspace/QA-Leica-wxwork-front/src/style/componentStyle/index-Page.less","index-Page.less"],"names":[],"mappings":";AAAA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;ACEJ","file":"index-Page.less","sourcesContent":[".Page {\n    width: 100%;\n    height: 100%;\n    overflow-y: auto;\n  }",".Page {\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n}\n"]}]);




//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76df2120","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/style/componentStyle/index-Page.less
// module id = iWlw
// module chunks = 1